import React from "react";

const PauseIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      id="pause_icon"
      data-name="pause"
      {...props}
      width={props.width || "20"}
      height={props.height || "20"}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.99935 1.66669C5.40435 1.66669 1.66602 5.40502 1.66602 10C1.66602 14.595 5.40435 18.3334 9.99935 18.3334C14.5943 18.3334 18.3327 14.595 18.3327 10C18.3327 5.40502 14.5943 1.66669 9.99935 1.66669ZM9.99935 16.6667C6.32352 16.6667 3.33268 13.6759 3.33268 10C3.33268 6.32419 6.32352 3.33335 9.99935 3.33335C13.6752 3.33335 16.666 6.32419 16.666 10C16.666 13.6759 13.6752 16.6667 9.99935 16.6667Z"
        fill={props.fill || "#3A8AB9"}
      />
      <path
        d="M10.8333 7.5H12.5V12.5H10.8333V7.5ZM7.5 7.5H9.16667V12.5H7.5V7.5Z"
        fill={props.fill || "#3A8AB9"}
      />
    </svg>
  );
};

export default PauseIcon;
